export function trimTeamAriInObject(team) {
  if (!team) {
    return team;
  }
  return {
    ...team,
    id: team.id.replace('ari:cloud:teams::team/', '').replace('ari:cloud:identity::team/', '')
  };
}
export const transformTeams = data => {
  if (!data || !data.entities) {
    return [];
  }
  return data.entities.map(trimTeamAriInObject);
};